/**
 * Fallback Hebrew translations for common terminology terms (used when school has legacy string format).
 */
const TERM_HE_FALLBACKS = {
  Level: 'רמה',
  Belt: 'חגורה',
  Exercise: 'תרגיל',
  Drill: 'תרגיל',
  Studio: 'סטודיו',
  Dojo: 'דוג\'ו',
};

/**
 * Get the localized terminology term for a school.
 * Supports both legacy format (plain string) and new format ({ nameEn, nameHe }).
 *
 * @param {Object} schoolData - School data with optional terminology
 * @param {string} key - Terminology key: 'school' | 'belt' | 'drill'
 * @param {string} language - Language code: 'he' | 'en'
 * @returns {string} The localized term, or fallback
 */
export function getTerminologyTerm(schoolData, key, language = 'en') {
  const terminology = schoolData?.terminology;
  if (!terminology?.[key]) return null;

  const term = terminology[key];
  const isHe = language === 'he';

  // New format: { nameEn, nameHe }
  if (typeof term === 'object' && term !== null) {
    let value = isHe ? term.nameHe : term.nameEn;
    if (!value) value = isHe ? term.nameEn : term.nameHe;
    // Fallback: when Hebrew requested but nameHe missing, use translation map
    if (isHe && value && !term.nameHe && TERM_HE_FALLBACKS[value]) {
      return TERM_HE_FALLBACKS[value];
    }
    return value || null;
  }

  // Legacy format: plain string (English) - use fallback for Hebrew
  if (typeof term === 'string') {
    return isHe ? (TERM_HE_FALLBACKS[term] ?? term) : term;
  }

  return null;
}
